const breakpointValues = ['1567px', '1279px', '999px', '767px', '359px'] as const;

export type BreakpointType = typeof breakpointValues[number];

export interface BreakpointsInterface {
    sDesktop: BreakpointType,
    laptop: BreakpointType,
    tablet: BreakpointType,
    mobile: BreakpointType,
    sMobile: BreakpointType,
}

const breakpoints: BreakpointsInterface = {
    sDesktop: breakpointValues[0],
    laptop: breakpointValues[1],
    tablet: breakpointValues[2],
    mobile: breakpointValues[3],
    sMobile: breakpointValues[4],
};

export default breakpoints;
